import React from 'react'
import styled from 'styled-components'
import Button from '../button/Button'
import { Link } from 'react-router-dom'


const StyledForm = styled.div`
box-shadow: 0px 10px 60px rgba(38, 45, 118, 0.08);
border-radius: 5px;
background: #FFF;
padding: 25px;
  form{
        .form__header{
            h2{
                font-weight: 700;
                font-size: 28px;
                line-height: 34px;
                color: #080055;
            }
    }

        .form__input{
                font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: center;
            color: #1C1939;
            padding-bottom: 10px;
               margin: 0 7px;

               .form__name{
                padding-right: 20px;
               }

              h3{
                padding-bottom: 5px;
              }
              
            input{
                padding: 9px;
                background: #FFFFFF;
                border: 1px solid #E4E4E4;
                outline-width: 0;
                border-radius: 3px;
              
                    ::placeholder{
                        font-weight: 400;
                    font-size: 13px;
                    line-height: 18px;
                    color: #C0C0C2;
                }

            }

            }

            .form__message{
                 h3{
                padding-bottom: 5px;
              }
              padding-bottom: 8px;
               textarea{
                    padding: 9px;
                    background: #FFFFFF;
                    border: 1px solid #E4E4E4;
                    border-radius: 3px;
                    outline-width: 0;
                    ::placeholder{
                        font-weight: 400;
                    font-size: 13px;
                    line-height: 18px;
                  
                    color: #C0C0C2;
                    }   
                 }
        
             }
}

`


export const Forms = () => {
  return (
    <StyledForm>
        <form>
            <div className='form__header'>
                <h2>Contact Us</h2>
            </div>

            <div className='form__input'>
                <div className='form__name'>
                    <h3>Full name</h3>
                    <input type='text' placeholder='Enter your full name' />
                </div>

                <div className='form__email'>
                     <h3>Email address</h3>
                      <input type='text' placeholder='Enter your Email address' />
                </div>
            </div>

             <div className="form__message">
                <h3>Message</h3>
                <textarea  placeholder='write message' rows="4" cols="50"></textarea>
             </div>
             <Link to='/user/login'><Button>Sign In</Button></Link>
        </form>
    </StyledForm>
  )
}
